import { http } from "../../services/apiProduct/Http.interceptor";

const URL: string = '/';

export const getProducts = (product: any) => {
    return http.post<any>(URL, { CONSULTA: product });
}
